import axiosInstance from "../../utils/axios";
import guestAxios from "@/utils/guestAxios";

const stripClientGuestIdentity = (payload = {}) => {
  const {
    guestSessionId,
    GuestSessionId,
    token,
    Token,
    sessionId,
    SessionId,
    ...safePayload
  } = payload || {};

  return safePayload;
};

export const guestRequestsApi = {
  getAll: (params = {}) => {
    return axiosInstance.get("/api/GuestRequests/GetAll", {
      params,
    });
  },

  getById: (id) => {
    return axiosInstance.get("/api/GuestRequests/GetById", {
      params: { id },
    });
  },

  updateStatus: (id, payload) => {
    return axiosInstance.patch("/api/GuestRequests/UpdateStatus", payload, {
      params: { id },
    });
  },

  delete: (id) => {
    return axiosInstance.delete("/api/GuestRequests/Delete", {
      params: { id },
    });
  },

  create: (payload = {}) => {
    return guestAxios.post(
      "/api/GuestRequests/Create",
      stripClientGuestIdentity(payload)
    );
  },

  guestGetById: (id, params = {}) => {
    return guestAxios.get("/api/GuestRequests/GuestGetById", {
      params: { id, ...stripClientGuestIdentity(params) },
    });
  },

  getBySessionId: (sessionId, params = {}) => {
    return axiosInstance.get("/api/GuestRequests/GetBySessionId", {
      params: { sessionId, ...params },
    });
  },

  getHistoryBySessionId: (sessionId, params = {}) => {
    return axiosInstance.get("/api/GuestRequests/GetHistoryBySessionId", {
      params: { sessionId, ...params },
    });
  },

  guestGetBySessionId: (_sessionId, params = {}) => {
    return guestAxios.get("/api/GuestRequests/GetBySessionId", {
      params: stripClientGuestIdentity(params),
    });
  },

  addNote: (id, payload = {}) => {
    return axiosInstance.post("/api/GuestRequests/AddNote", payload, {
      params: { id },
    });
  },

  remind: (id, payload = {}) => {
    return guestAxios.post(
      `/api/GuestRequests/Remind/${id}`,
      stripClientGuestIdentity({ ...payload, id, guestRequestId: id }),
      {
        params: { id, queryId: id, requestId: id },
      }
    );
  },
};